<template>

  <v-card-text>
    <v-alert type="error"
             outlined
             dense
             :key="i"
             v-for="(message, i) in errorMessages">
      {{ message }}
    </v-alert>

    <v-alert type="warning"
             outlined
             dense
             :key="i"
             v-for="(message, i) in warningMessages">
      {{ message }}
    </v-alert>

    <v-alert type="success"
             outlined
             dense
             :key="i"
             v-for="(message, i) in successMessages">
      {{ message }}
    </v-alert>


  </v-card-text>

</template>

<script>

export default {
  name: 'SharedPageMessages',

  props: {
    errorMessages: {
      type: Array
    },
    successMessages: {
      type: Array,
    },
    warningMessages: {
      type: Array,
    }
  },

  watch: {
    errorMessages: function () {
      scroll(0, 0)
    },
    successMessages: function () {
      scroll(0, 0)
    },
    warningMessages: function () {
      scroll(0, 0)
    }
  },
}

</script>
